import { Button, Highlight, Stack } from '@optimus-web/core';

export const DefaultError: React.FC<{ retry(): void }> = ({ retry }) => (
    <Stack spacing="100" vertical itemAlignment="center">
        <Highlight size="medium">Loading failed</Highlight>
        <Button onClick={retry} type="submit">
            Retry
        </Button>
    </Stack>
);
